import api from '..';

export const getConversionRateRequest = (payload) => {
  return api.post('/payments/rate', payload);
};

export const createTransferRequest = (payload) => {
  return api.post('/payments/transfer', payload);
};
